import { render } from "./PublishedOnClassroom.vue?vue&type=template&id=3b3e0cf8&ts=true"
import script from "./PublishedOnClassroom.vue?vue&type=script&lang=ts"
export * from "./PublishedOnClassroom.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__